import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { attributesStyles } from "@dana/Overrides/Widgets/ProductDetails/ProductDetailsAttributes";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

attributesStyles.wrapper = mergeToNew(attributesStyles.wrapper, {
    css: css`
        width: auto;
        border: 1px solid ${themeBackgrounds.lightGray};
        padding-bottom: 0;
    `,
});
attributesStyles.attributeTypeLabelText = mergeToNew(attributesStyles.attributeTypeLabelText, {
    weight: "normal",
    lineHeights: lineHeights.defaultLarge,
    css: css`
        border-right: 1px solid ${themeBackgrounds.lightGray};
        padding: 8px 0;
    `,
});
attributesStyles.attributeTypeValuesText = mergeToNew(attributesStyles.attributeTypeValuesText, {
    lineHeights: lineHeights.defaultLarge,
    css: css`
        padding: 0 8px;
        display: grid;
        grid-template-columns: 300px 1fr;
        grid-gap: 8px;
        align-items: center;
        margin-bottom: 0;

        &:not(:last-child) {
            border-bottom: 1px solid ${themeBackgrounds.lightGray};
        }
    `,
});
